<template>
  <div class="pf-mini-tag__container">
    <div
      class="pf-mini-tag"
      :id="id"
      @mouseover="toggleTool = true"
      @mouseleave="toggleTool = false"
      @focus="toggleTool = true"
      @blur="toggleTool = false"
    ></div>
    <mds-tooltip :triggered-by="id" v-model="toggleTool" :position="['top-center']">
      {{ content }}
    </mds-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'PfMiniTag',
    props: {
      content: {
        type: String,
      },
      id: {
        type: String,
      },
    },
    data() {
      return {
        toggleTool: false,
      };
    },
  };
</script>

<style lang="scss">
  @import '@mds/constants';

  .pf-mini-tag {
    height: 21px;
    border-radius: 50%;
    aspect-ratio: 1/1;
    cursor: pointer;

    &__container {
      position: absolute;
    }

    &:focus {
      box-shadow: $mds-box-shadow-focus;
      outline: none;
    }

    // indicator dot fill outline
    &::after {
      background-color: $mds-interactive-color-primary-default;
      border-radius: 50%;
      content: '';
      display: block;
      height: 100%;
      transform: scale(0.5); // Hide border
      transform-origin: center center;
      transition: $mds-animation-timing-2-x;
      width: 100%;
    }

    // indicator dot fill
    &::before {
      background: transparent;
      border: solid 2px $mds-interactive-color-primary-default;
      border-radius: 50%;
      content: '';
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      transform: scale(11 / 21);
      transform-origin: center center;
      transition: transform $mds-animation-timing-2-x, background-color $mds-animation-timing-2-x;
      width: 100%;
      z-index: 2;
    }
  }
</style>
